import {domainIncidentAPI} from 'features/domain/api/domainIncidentAPI';
import {ILastIncidents} from 'entities/monitor';
import {getPollingInterval} from 'shared/api/pollingHelper';

import IDomainIncident from './DomainIncident/IDomainIncident';

export const useLastDomainIncidents = (limit: number): ILastIncidents<IDomainIncident> => {
    const {data: pagination, isLoading, isFetching} = domainIncidentAPI.useGetDomainIncidentsAllQuery(
        {limit},
        {pollingInterval: getPollingInterval()},
    );

    return {pagination, isLoading, isFetching};
};

export default useLastDomainIncidents;
